module.exports = __webpack_public_path__ + "static/media/19.d7e8c269.jpg";